import { makeAutoObservable, observable } from 'mobx';
import { basicRequestGet } from '../../Requests/basicRequestGet';
export class OrganizationsStoreActionsClass {
  @observable loadingError: boolean = false;

  @observable loading: boolean = false;

  @observable loadingDelete: boolean = false;
  @observable dataList: [] = [];
  @observable dataList1: [] = [];
  constructor() {
    makeAutoObservable(this);
  }

  async getList(workspaceId: string) {
    console.log('---- ww|OrganizationsStore|getList');
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.loadingError = false;
    this.dataList = [];

    try {
      const res = await basicRequestGet(`/workspaces/${workspaceId}/organizations`);
      console.log('---- ww|getList|res.data=', res.data.data);
      // this.dataList = res.data.data.docs.map((i: any, k: number) => {
      //   i.key = k + 1;
      //   // i.tags = [];
      //   return i;
      // });
      this.dataList = res.data.data;
      console.log('organizations: ', this.dataList);
    } catch (error) {
      // throw error;
      console.error('getList|error=', error);
      this.loadingError = true;
    } finally {
      this.loading = false;
    }
  }

  async getList1(workspaceId: string, query: string) {
    console.log('---- ww|OrganizationsStore|getList');
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.loadingError = false;
    this.dataList1 = [];

    try {
      const res = await basicRequestGet(
        `/workspaces/${workspaceId}/jobs/suggestionsForAddress?query=${query}`,
        query
      );
      console.log('---- ww|suggestionsForAddress|res.data=', res.data.suggestions);

      this.dataList1 = res.data.suggestions;
      console.log('organizations: ', this.dataList1);
    } catch (error) {
      // throw error;
      console.error('getList|error=', error);
      this.loadingError = true;
    } finally {
      this.loading = false;
    }
  }
}
